import React, { RefObject, useMemo, useState } from 'react';
import moment from 'moment';
import ReactGA from 'react-ga4';

import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { FormattedMessage, WrappedComponentProps, injectIntl } from 'react-intl';

import {
  ButtonStripeComplete,
  ExpiredSessionModal,
  InsuranceRequiredMessage,
  ModalMessage,
  ThreeDSModal,
} from '@components';

import { Checkbox, Spin } from 'antd';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BlueButton } from '@share/components';
import { GetWalletNumber, IsImpersonatingStore, RootState, UrlUtils, getPreferenceFromAccount, getToken, isEnableCreditLine, isValidEmail, renderNumber, LoginType, getCurrencyText, roundMoney2, dollarsToStripeCents, GetEffectiveClientCashPercentage } from '@share/utils';
import { GetPreferenceValue, MERCHANT_CHARGE_DESCRIPTION_FIELD_KEY, WalletPriceType, getWalletPrices } from '@utils';
import { ICarsState, ILoginState, IMarginatorState } from '@share/store/slices';
import { ICarsDetailsState, ICarsReviewBookState, getCarsBookPackageWithCard } from '@store/slices';
import { isEmpty } from 'lodash';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { CheckboxChangeEventTarget } from 'antd/lib/checkbox/Checkbox';

import { CancellationPolicies } from '../cars-cancellation-policies';
import { FormInstance } from 'antd/lib/form';
import { IBookPackageWithCard, IFormErrors, ScrollBehaviorEnum } from '@common-types';
import { C_PP, C_TERMS, DATE_FORMAT_FILTER, LIFE_STYLE_NAME_PARAM, Routes, SESSION_KEY_TOKEN_NAME_PARAM, USER_BASE_URL } from '@share/constants';
import { IAccount, LOGOUT_FIELD_KEY } from '@share/common-types';

import './style.scss';
import { Elements } from '@stripe/react-stripe-js';
import ExpressCheckoutButtons from '../../../../../share/components/express-checkout-buttons/component';
import ForceFullStripeCheckout from '../../../../../share/components/express-checkout-buttons/force-full-section/component';
import GlobalLoading from '../../../../../share/components/global-spinner/component';
import { StripeBtnTypes, stripePromise } from '../../../../../share/utils/stripe';

const ZERO = 0;

interface IMapStateToProps {
  marginatorStore: IMarginatorState;
  loginStore: ILoginState;

  carsStore: ICarsState;
  carsDetailsStore: ICarsDetailsState;
  carsReviewBookStore: ICarsReviewBookState;
}

interface IMapDispatchToProps {
  getBookPackageWithCard: (bookWithCard: IBookPackageWithCard) => void;
}


interface IProps extends IMapStateToProps, IMapDispatchToProps, WrappedComponentProps {
  paymentFormRef: RefObject<FormInstance>;
  driverFormRef: RefObject<FormInstance>;
  emailFormRef: RefObject<FormInstance>;
  billingRef: RefObject<FormInstance>;
  isButtonCompleteHidden: ButtonStripeComplete;
  setMultiplePayments?: (payment: any) => void;
  paymentSelected: string;
  /** Raw wallet picker value for Stripe Express options (not paymentEffective, which is 'card' during probe). */
  expressCheckoutPaymentSelected: string;
  validateStripeBtns: boolean;
  scrollToPaymentSelectDisabled?: () => void;
  scrollToPaymentSelectEnabled?: () => void;
  shouldMountStripeExpressElements?: boolean;
  expressWalletProbeComplete?: boolean;
  onExpressWalletAvailabilityResolved?: (hasWallets: boolean) => void;
  suppressStripePaymentUI?: boolean;
  forceFullStripeCheckoutPhase?: 'details' | 'payment';
  onForceFullStripeCheckoutNext?: () => void;
  onForceFullStripeCheckoutBack?: () => void;
  insuranceContainerRef?: React.RefObject<HTMLDivElement>;
  insuranceRequiredMessageDisplay?: boolean;
}

const STRIPE_EXPRESS_PROBE_SR_ONLY: React.CSSProperties = {
  position: 'fixed',
  left: 0,
  top: 0,
  width: 'min(100vw, 480px)',
  height: 52,
  opacity: 0,
  pointerEvents: 'none',
  zIndex: -1,
  overflow: 'hidden',
};

function CarsDisclaimersComponent(props: IProps) {
  const [showNotRefundableMessage, setShowNotRefundableMessage] = useState(false);
  const [isClientCashNotRefundable, setIsClientCashNotRefundable] = useState(false);
  const [isAccept, setIsAccept] = useState(false);
  const [isClientCash, setIsClientCash] = useState(false);
  const [isAcceptBookingRemarks, setIsAcceptBookingRemarks] = useState(false);
  const [isAcceptCancellationPolicy, setIsAcceptCancellationPolicy] = useState(false);
  const [isAcceptAgeRestriction, setIsAcceptAgeRestriction] = useState(false);
  const [isAcceptMajorCreditCard, setIsAcceptMajorCreditCard] = useState(false);
  const [isSessionExpired, setIsSessionExpired] = useState(false);
  const [isReward, setIsReward] = useState(false);

  const history = useHistory();

  const {
    loginStore,
    carsStore,
    marginatorStore,
    carsDetailsStore,
    carsReviewBookStore,
    paymentFormRef,
    driverFormRef,
    emailFormRef,
    intl,
    getBookPackageWithCard,
    billingRef,
    setMultiplePayments,
    paymentSelected,
    expressCheckoutPaymentSelected,
    validateStripeBtns,
    scrollToPaymentSelectDisabled,
    scrollToPaymentSelectEnabled,
    shouldMountStripeExpressElements = false,
    expressWalletProbeComplete = false,
    onExpressWalletAvailabilityResolved,
    suppressStripePaymentUI = false,
    forceFullStripeCheckoutPhase = 'details',
    onForceFullStripeCheckoutNext,
    onForceFullStripeCheckoutBack,
    insuranceContainerRef,
    insuranceRequiredMessageDisplay = false,
  } = props;
  const { account, userWallet, userWalletData, userWalletReward } = loginStore;
  const { value } = marginatorStore;
  const { selectedCarsSearchClientCash } = carsStore;
  const { loading, car } = carsDetailsStore;
  const {
    driver,
    selectedCarsReviewClientCash,
    loadingBooking,
    isSoldOutError,
    rewardId,
    stripeLoading,
  } = carsReviewBookStore;

  const currency = car?.currency;
  const payNowPrice = car?.payNowPrice;
  const maxWalletClientCash = car?.maxWalletClientCash;
  const maxRewardWalletAmount = car?.maxRewardWalletAmount;

  const hasClientCash = account?.hasClientCash;
  const enableWalletReward = account?.enableWalletReward;
  const effectiveClientCashPercentage = GetEffectiveClientCashPercentage(loginStore);
  const isLogged = !!userWallet;

  const marginatorPrice = (payNowPrice ?? 0) / (1 - (value / 100));

  const walletPrices = getWalletPrices(account, userWalletData, selectedCarsSearchClientCash, marginatorPrice, maxWalletClientCash, WalletPriceType.Book);

  const displayWalletSavings = account?.walletWalletSavings && (walletPrices?.priceSavings > 0 || walletPrices?.maxClientCashAmountAllow > 0) && !!walletPrices?.maxClientCashAmountAllow;

  const marginatorPriceFinal = displayWalletSavings ? walletPrices?.priceFinalMax : walletPrices?.priceFinal;

  const eligibleClientCash = (marginatorPriceFinal > 0 ? marginatorPriceFinal : 0) * effectiveClientCashPercentage / 100;

  const token = useMemo(() => getToken(account), [account]);

  const chargeDescription = GetPreferenceValue(account as IAccount, MERCHANT_CHARGE_DESCRIPTION_FIELD_KEY);
  const walletNoDecimals = account?.walletNoDecimals;
  const walletIsExternal = account?.walletIsExternal;
  const walletSkipNonRefundable = account?.walletSkipNonRefundable;
  const walletNoPassEarnings = account?.walletNoPassEarnings;

  const convertionRate = userWalletData?.convertionRate ? userWalletData?.convertionRate : 1;

  const balanceCalculated = marginatorPrice / convertionRate;

  const maxWalletClientCashCalculated = maxWalletClientCash ? walletNoDecimals ? Math.floor(maxWalletClientCash / convertionRate) : maxWalletClientCash / convertionRate : null;
  const userWalletDataBalanceCalculated = (walletNoDecimals && userWalletData?.balance) ? Math.floor(userWalletData?.balance) : userWalletData?.balance;
  const maxWalletAmountIntermediated = walletNoPassEarnings ?
    maxWalletClientCashCalculated ?
      (maxWalletClientCashCalculated && (userWalletDataBalanceCalculated ?? 0) > maxWalletClientCashCalculated) ?
        maxWalletClientCashCalculated :
        userWalletDataBalanceCalculated :
      0 :
    (userWalletDataBalanceCalculated ?? 0) > balanceCalculated ?
      balanceCalculated : 
      userWalletDataBalanceCalculated;

  const maxWalletAmount = (maxWalletClientCashCalculated && (maxWalletAmountIntermediated ?? 0) > maxWalletClientCashCalculated) ? maxWalletClientCashCalculated : maxWalletAmountIntermediated;

  const clientCash = selectedCarsReviewClientCash ? GetWalletNumber(selectedCarsReviewClientCash, account) : Number(0).toFixed(walletNoDecimals ? 0 : 2);

  const onChangeAccept = (e: { target: CheckboxChangeEventTarget }): void => {
    setIsAccept(e.target.checked);
  };

  const onChangeAcceptBookingRemarks = (e: { target: CheckboxChangeEventTarget }): void => {
    setIsAcceptBookingRemarks(e.target.checked);
  };

  const onChangeAcceptClientCash = (e: { target: CheckboxChangeEventTarget }): void => {
    setIsClientCash(e.target.checked);
  };

  const onChangeAcceptClientCashNotRefundable = (e: { target: CheckboxChangeEventTarget }): void => {
    setIsClientCashNotRefundable(e.target.checked);
    setShowNotRefundableMessage(e.target.checked);
  };

  const onChangeAcceptCancellationPolicy = (e: { target: CheckboxChangeEventTarget }): void => {
    setIsAcceptCancellationPolicy(e.target.checked);
  };

  const onChangeAcceptAgeRestriction = (e: { target: CheckboxChangeEventTarget }): void => {
    setIsAcceptAgeRestriction(e.target.checked);
  };

  const onChangeAcceptMajorCreditCard = (e: { target: CheckboxChangeEventTarget }): void => {
    setIsAcceptMajorCreditCard(e.target.checked);
  };

  const onChangeAcceptReward = (e: { target: CheckboxChangeEventTarget }): void => {
    setIsReward(e.target.checked);
  };

  const hangleGoToLogin = () => {
    history.push(`/${account?.name}${Routes.Login}`);
  };

  const hangleGoToSignUp = () => {
    history.push(`/${account?.name}${Routes.SignUp}`);
  };

  const handleRedirect = () => {
    const { account: acc } = loginStore;

    const logoutUrlStorage = localStorage.getItem(USER_BASE_URL);
    const logoutPref = getPreferenceFromAccount(acc, LOGOUT_FIELD_KEY);
    const logoutUrl = !isEmpty(logoutUrlStorage) ? logoutUrlStorage : logoutPref;
    if (!isEmpty(logoutUrl)) {
      window.location.replace(logoutUrl);
    }
  }

  const handleOnCompleteBooking = () => {
    const { carsReviewBookStore, carsDetailsStore, loginStore } = props;

    const { card, driver, loadingBooking, isSoldOutError, selectedCarsReviewClientCash, stripe } = carsReviewBookStore;
    /*const { referenceNumber, agencyNumber } = hotelsStore;*/
    const { account, userWallet, userWalletData } = loginStore;
    const { car } = carsDetailsStore;

    const balance = car?.price;
    const convertionRate = userWalletData?.convertionRate ? userWalletData?.convertionRate : 1;
    const finalBalanceIntermediate = (balance ?? 0) - (selectedCarsReviewClientCash ? selectedCarsReviewClientCash * convertionRate : 0);
    const finalBalance = roundMoney2(finalBalanceIntermediate);

    const isPrivateWithToken = account?.type === LoginType.PrivateWithToken;

    if (isPrivateWithToken && !token) {
      setIsSessionExpired(true);
      return;
    }

    if (loadingBooking || isSoldOutError || !isAccept || !isAcceptBookingRemarks || !isAcceptCancellationPolicy || !isAcceptAgeRestriction || !isAcceptMajorCreditCard) {
      return;
    }

    /*
    let quote;
    if (values[QUOTE_LABEL]) {
      quote = (values[QUOTE_LABEL] as string);
      }
      */

      const skipPayment = isEnableCreditLine(account);

      const data: any = {
        /*
        sessionKey,
        marginator: {
         percentage: marginatorStore.percentage,
         commission: marginatorStore.commission,
         impersonator: {
           memberId: marginatorStore.impersonator.memberId
           }
           },
           quote,
           */
  
        marginator: {
          percentage: marginatorStore.percentage,
          commission: marginatorStore.commission,
          impersonator: {
            memberId: marginatorStore.impersonator.memberId
          }
        },
  
        id: car?.id,
        customer: {
          primary: {
            personName: {
              givenName: driver?.givenName,
              surname: driver?.surname
            },
            telephone: {
              phoneTechType: '1',
              phoneNumber: driver?.phone
            },
            email: driver?.email,
            address: skipPayment
              ? {
                  streetNmbr: stripe?.addressLine ?? '',
                  cityName: stripe?.city ?? '',
                  postalCode: stripe?.zipCode ?? '',
                  stateCode: stripe?.state ?? '',
                  stateProv: stripe?.state ?? '',
                }
              : {
                  streetNmbr: card?.addressLine,
                  cityName: card?.city,
                  postalCode: card?.zipCode,
                  stateCode: card?.state,
                  stateProv: card?.state,
                },
            countryCode: driver?.country,
            birthDate: `${moment(driver?.birthDate, DATE_FORMAT_FILTER).format('yyyy-MM-DD')}`,
            language: 'EN',
          }
        },
        currency: account?.currency,
      };

      if (!skipPayment) {
        data.card = {
          addressLine: card?.addressLine,
          addressLine2: null,
          CVV: card?.cvv,
          cardNumber: card?.cardNumber,
          cardType: card?.cardType,
          city: card?.city,
          state: card?.state,
          country: card?.country,
          expireDate: card?.expireDate,
          holderName: card?.holderName,
          phone: driver?.phone,
          zipCode: card?.zipCode,
          addPaymentMethod: card?.addPaymentMethod,
        };
      }

    const impersonatingStore = IsImpersonatingStore();
    const privateTokenFromUrl = account?.privateTokenFromUrl;
    if (isPrivateWithToken && privateTokenFromUrl) {
      const ssoSessionKey = UrlUtils.getSearchParam(SESSION_KEY_TOKEN_NAME_PARAM);
      data.ssoSessionKey = ssoSessionKey;
      data.lifeType = UrlUtils.getSearchParam(LIFE_STYLE_NAME_PARAM);
    } else if (!isEmpty(impersonatingStore)) {
      data.lifeType = impersonatingStore;
    }



    const hasClientCash = account?.hasClientCash;
    const isLogged = !!userWallet;

    if (!skipPayment) {
      const paymentMethod = { paymentMethodId: card?.id, CVC: card?.cvv };
      const creditCard = { ...data.card };

      if (hasClientCash && isLogged) {
        data.clientCashAmount = selectedCarsReviewClientCash ? selectedCarsReviewClientCash : 0;

        if (finalBalance > 0) {
          if (!isEmpty(card?.id)) {
            data.paymentMethod = paymentMethod;
          } else {
            data.card = creditCard;
          }
        }
      } else {
        if (!isEmpty(card?.id)) {
          data.paymentMethod = paymentMethod;
        } else {
          data.card = creditCard;
        }
      }
    } else if (hasClientCash && isLogged) {
      data.clientCashAmount = selectedCarsReviewClientCash ? selectedCarsReviewClientCash : 0;
    }

    const formPayment = skipPayment ? undefined : paymentFormRef.current?.validateFields();
    const formBilling = skipPayment ? billingRef.current?.validateFields() : undefined;
    const formDriver = driverFormRef.current?.validateFields();
    const formEmail = emailFormRef.current?.validateFields();

    Promise.all([formPayment, formBilling, formDriver, formEmail].filter(Boolean))
      .then(() => {
        getBookPackageWithCard(data);
      })
      .catch((error: IFormErrors) => {
        const { errorFields } = error;
        const { name } = errorFields[ZERO];

        const { scrollToField: scrollToPaymentField } = paymentFormRef.current ?? {};
        const { scrollToField: scrollToDriverField } = driverFormRef.current ?? {};
        const { scrollToField: scrollToEmailField } = emailFormRef.current ?? {};
        const { scrollToField: scrollToBillingField } = billingRef.current ?? {};

        (() => {
          scrollToEmailField?.(name[ZERO], { behavior: ScrollBehaviorEnum.Smooth });
          scrollToPaymentField?.(name[ZERO], { behavior: ScrollBehaviorEnum.Smooth });
          scrollToDriverField?.(name[ZERO], { behavior: ScrollBehaviorEnum.Smooth });
          scrollToBillingField?.(name[ZERO], { behavior: ScrollBehaviorEnum.Smooth });
        })();
      });

  }

  /** Match Google Pay / Express to net pay-now (payNowPrice − points − reward), not base car.price. */
  const pointsDiscountCurrency = selectedCarsReviewClientCash
    ? selectedCarsReviewClientCash * convertionRate
    : 0;
  const rewardDeductionExpress =
    rewardId && maxRewardWalletAmount ? maxRewardWalletAmount : 0;
  const expressChargeTotalDollars = Math.max(
    0,
    (payNowPrice ?? 0) - pointsDiscountCurrency - rewardDeductionExpress,
  );
  const finalAmount = dollarsToStripeCents(expressChargeTotalDollars);

  const skipPaymentCheckout = isEnableCreditLine(account);
  const isCardPayment =
    !skipPaymentCheckout && !isEmpty(paymentSelected) && paymentSelected === 'card';
  const showCompleteBookingButton = skipPaymentCheckout || isCardPayment;

  const isOtherPayment = !isEmpty(paymentSelected) && paymentSelected !== 'card';

 const validateForm = () => {
       if (insuranceRequiredMessageDisplay && insuranceContainerRef?.current) {
         insuranceContainerRef.current.scrollIntoView({
           behavior: 'smooth',
           block: 'start',
         });
         return;
       }

       const formDriverRefValidate = driverFormRef.current?.validateFields();
       const formEmailRefValidate = emailFormRef.current?.validateFields();
       const formBillingRefValidate = billingRef.current?.validateFields();
       const paymentFormRefValidate = paymentFormRef.current?.validateFields();
       let promises = [formDriverRefValidate, formEmailRefValidate];
       const shouldIncludePayment = isCardPayment && !skipPaymentCheckout;
 
       if (shouldIncludePayment && paymentFormRefValidate) {
         promises.push(paymentFormRefValidate);
       } else {
         promises = [formDriverRefValidate, formEmailRefValidate, formBillingRefValidate];
       }
 
       if (!skipPaymentCheckout && isEmpty(paymentSelected)) {
        scrollToPaymentSelectEnabled?.();
         const paymentSection = document.getElementById("payment-methods-select__card");
         if (paymentSection) {
           paymentSection.scrollIntoView({ behavior: "smooth", block: "center" });
         }
       } else {
         scrollToPaymentSelectDisabled?.();
       }
 
       Promise.all(promises)
         .catch((error: IFormErrors) => {
           const { errorFields } = error;
           const { name } = errorFields[0];
 
           const { scrollToField: scrollToDriverField } = driverFormRef.current ?? {};
           const { scrollToField: scrollToEmailField } = emailFormRef.current ?? {};
 
           scrollToDriverField?.(name[0], { behavior: ScrollBehaviorEnum.Smooth });
 
           scrollToEmailField?.(name[0], { behavior: ScrollBehaviorEnum.Smooth });
 
           if (shouldIncludePayment && paymentFormRef.current) {
             const { scrollToField: scrollToPaymentField } = paymentFormRef.current;
             scrollToPaymentField(name[0], { behavior: ScrollBehaviorEnum.Smooth });
           }
           if (!shouldIncludePayment && billingRef.current) {
            const { scrollToField: scrollToBillingField } = billingRef.current;
            scrollToBillingField(name[0], { behavior: ScrollBehaviorEnum.Smooth });
          }
         });
     };

  const maxWalletBound = maxWalletAmount ?? 0;
  /** Block submission whenever the entered driver email is empty / malformed. Applies to every
   *  payment path — non-Stripe legacy, hybrid wallets, force-full phase-1 Next, force-full phase-2
   *  Complete — since all of those flow through this single compound. */
  const isDriverEmailValid = isValidEmail(driver?.email);
  const isCardCompleteBookingDisabled =
    !validateStripeBtns ||
    !isDriverEmailValid ||
    isSoldOutError ||
    loadingBooking ||
    !isAccept ||
    !isAcceptBookingRemarks ||
    !isAcceptCancellationPolicy ||
    !isAcceptAgeRestriction ||
    !isAcceptMajorCreditCard ||
    (hasClientCash && isLogged && !isClientCash) ||
    (enableWalletReward && isLogged && !isReward) ||
    (hasClientCash &&
      isLogged &&
      !isClientCashNotRefundable &&
      (selectedCarsReviewClientCash ?? 0) > 0 &&
      !walletIsExternal &&
      !walletSkipNonRefundable) ||
    (hasClientCash && isLogged && (selectedCarsReviewClientCash ?? 0) > maxWalletBound) ||
    (hasClientCash &&
      isLogged &&
      !!selectedCarsReviewClientCash &&
      selectedCarsReviewClientCash <= maxWalletBound &&
      walletNoDecimals &&
      Math.floor(selectedCarsReviewClientCash) != selectedCarsReviewClientCash);

  const isForceFullStripePaymentStep =
    suppressStripePaymentUI && forceFullStripeCheckoutPhase === 'payment';

  return (
    <div
      className={`hotel-info cars-details-disclaimer${
        suppressStripePaymentUI ? ' force-stripe-full-active' : ''
      }${
        isForceFullStripePaymentStep ? ' cars-details-disclaimer--separator-after-car-details' : ''
      }`}
    >
      <div className="hotel-info__item">
        <div className="hotel-info__item-content">
          {(!suppressStripePaymentUI || forceFullStripeCheckoutPhase === 'details') && (
          <>
          <CancellationPolicies
            displayCheckbox={true}
            disable={loading || loadingBooking}
            onChangeAcceptPolicy={onChangeAcceptCancellationPolicy}
          />

          <div className="review-book__wrapper">
            <Checkbox onChange={onChangeAccept} disabled={loading || loadingBooking} />
            <p className="review-book__accept-text">
              <FormattedMessage
                id="accept.you.will.be.charged"
                values={{
                  price: renderNumber(marginatorPriceFinal, 2),
                  type: <FormattedMessage id="Hotel" />,
                  reservation_name: (!isEmpty(chargeDescription)) ? chargeDescription : <FormattedMessage id="accept.you.will.be.charged.travcoding" />,
                  currency: currency
                }}
              />
            </p>
          </div>

          <div className="review-book__wrapper">
            <Checkbox
              onChange={onChangeAcceptBookingRemarks}
              disabled={loading || loadingBooking}
            />
            <p className="review-book__accept-text">
              <FormattedMessage
                id="cars.by.checking.this.box.you.acknowledge.that.you.have.read"
                values={{
                  pp: (msg: React.ReactNode[]) => {
                    return (
                      <a target="_blank" rel="noreferrer" href="https://www.travcoding.com/privacy-policy/" onClick={() => {
                        ReactGA.event({
                          category: account?.name as string,
                          action: `${C_PP}_${account?.name.toUpperCase()}`,
                          label: `User clicked privacy policy on book`,
                          nonInteraction: false,
                        });
                      }}>
                        {msg}
                      </a>
                    );
                  },
                  tu: (msg: React.ReactNode[]) => {
                    return (
                      <a target="_blank" rel="noreferrer" href="https://www.travcoding.com/terms-of-use/" onClick={() => {
                        ReactGA.event({
                          category: account?.name as string,
                          action: `${C_TERMS}_${account?.name.toUpperCase()}`,
                          label: `User clicked terms of use on book`,
                          nonInteraction: false,
                        });
                      }}>
                        {msg}
                      </a>
                    );
                  },
                }}
              />
            </p>
          </div>

          <div className="review-book__wrapper">
            <Checkbox
              onChange={onChangeAcceptAgeRestriction}
              disabled={loading || loadingBooking}
            />
            <p className="review-book__accept-text">
              <FormattedMessage id="by.checking.this.box.you.acknowledge.age.restriction" />
            </p>
          </div>

          <div className="review-book__wrapper">
            <Checkbox
              onChange={onChangeAcceptMajorCreditCard}
              disabled={loading || loadingBooking}
            />
            <p className="review-book__accept-text">
              <FormattedMessage id="by.checking.this.box.you.acknowledge.major.credit.cards" />
            </p>
          </div>

          {hasClientCash && isLogged && (
            <div className="review-book__wrapper">
              <Checkbox onChange={onChangeAcceptClientCash} disabled={loading || loadingBooking} />
              <p className="review-book__accept-text">
                {!walletIsExternal ? (
                  <FormattedMessage
                    id={
                      effectiveClientCashPercentage > 0
                        ? 'wallet.client.cash.by.checking.acknowledge'
                        : 'wallet.client.cash.by.checking.acknowledge.no_earnings'
                    }
                    values={{
                      clientCash,
                      reward: walletNoDecimals
                        ? Math.floor(eligibleClientCash).toFixed(0)
                        : eligibleClientCash.toFixed(2),
                      clientCashPercentage: effectiveClientCashPercentage,
                      clientCashName: account?.walletClientCashName,
                    }}
                  />
                ) : (
                  <FormattedMessage
                    id="wallet.client.cash.by.checking.acknowledge.external"
                    values={{ clientCash, clientCashName: account?.walletClientCashName }}
                  />
                )}
              </p>
            </div>
          )}

          {!walletSkipNonRefundable && !walletIsExternal && hasClientCash && isLogged && (selectedCarsReviewClientCash ?? 0) > 0 && (
            <div className="review-book__wrapper">
              <Checkbox
                onChange={onChangeAcceptClientCashNotRefundable}
                disabled={loading || loadingBooking}
              />
              <p className="review-book__accept-text">
                <FormattedMessage
                  id="wallet.client.not_refundable.acknowledge"
                  values={{ clientCash, clientCashName: account?.walletClientCashName }}
                />
              </p>

              <ModalMessage
                text={intl.formatMessage(
                  { id: 'wallet.client.not_refundable.modal.acknowledge' },
                  { clientCashName: account?.walletClientCashName },
                )}
                disableTextLocalization
                disableTitleLocalization={true}
                visible={showNotRefundableMessage}
                onCancel={() => setShowNotRefundableMessage(false)}
              />
            </div>
          )}

          {enableWalletReward && isLogged && (
            <div className="review-book__wrapper">
              <Checkbox onChange={onChangeAcceptReward} disabled={loading || loadingBooking} />
              <p className="review-book__accept-text">
                {rewardId ? (
                  <FormattedMessage
                    id="wallet.reward.by.checking.acknowledge"
                    values={{
                      rewardFormatted: `${getCurrencyText(currency)}${renderNumber((userWalletReward?.allRewards ?? []).find((r) => r.rewardId === rewardId)?.rewardValue ?? 0, 2)}`,
                      maxRewardFormatted: `${getCurrencyText(currency)}${renderNumber(maxRewardWalletAmount ?? 0, 2)}`,
                    }}
                  />
                ) : (
                  <FormattedMessage id="wallet.reward.by.checking.acknowledge.not_using" />
                )}
              </p>
            </div>
          )}

          {hasClientCash && !isLogged && effectiveClientCashPercentage > 0 && (
            <div className="review-book__wrapper client-cash-message">
              <p className="review-book__accept-text">
                <FontAwesomeIcon icon={faTriangleExclamation} />{' '}
                <FormattedMessage
                  id="wallet.client.not_logged.acknowledge"
                  values={{
                    reward: eligibleClientCash.toFixed(2),
                    currency: currency,
                    clientCashPercentage: effectiveClientCashPercentage,
                    clientCashName: account?.walletClientCashName,
                  }}
                />
              </p>
              <p
                className="booking-confirmed__contact-property"
                style={{ fontSize: '18px', marginTop: '10px', textAlign: 'right' }}
              >
                <BlueButton onClick={hangleGoToLogin}>
                  <FormattedMessage id="sign.in" />
                </BlueButton>{' '}
                <FormattedMessage id="or" />{' '}
                <BlueButton onClick={hangleGoToSignUp}>
                  <FormattedMessage id="sign.up" />
                </BlueButton>
              </p>
            </div>
          )}
          </>
          )}

          <div
            className={[
              'review-book__complete-btn',
              isOtherPayment || suppressStripePaymentUI ? 'others-methods' : '',
              suppressStripePaymentUI ? 'force-stripe-full-checkout' : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            <>
              {suppressStripePaymentUI &&
                forceFullStripeCheckoutPhase === 'details' &&
                onForceFullStripeCheckoutNext && (
                  <div className="stripe-force-full-next">
                    <BlueButton
                      onClick={onForceFullStripeCheckoutNext}
                      disabled={isCardCompleteBookingDisabled}
                    >
                      <FormattedMessage id="review.book.checkout.next" />
                    </BlueButton>
                  </div>
                )}
              {suppressStripePaymentUI && isForceFullStripePaymentStep && (
                <>
                  <h4 className="condo-payment__title secondary-font">
                    <FormattedMessage id="payment.methods" />
                  </h4>
                  <ForceFullStripeCheckout
                    type={StripeBtnTypes.Cars}
                    amount={finalAmount}
                    currency={account?.currency}
                    totalPrice={finalAmount}
                    isDisabled={isCardCompleteBookingDisabled}
                    forceFullStripeBack={
                      onForceFullStripeCheckoutBack
                        ? {
                            onClick: onForceFullStripeCheckoutBack,
                            disabled: loadingBooking || stripeLoading,
                          }
                        : undefined
                    }
                  />
                </>
              )}
              {!suppressStripePaymentUI && shouldMountStripeExpressElements && (
              <div
                style={
                  !expressWalletProbeComplete
                    ? STRIPE_EXPRESS_PROBE_SR_ONLY
                    : { display: isOtherPayment ? '' : 'none' }
                }
              >
                <Elements
                  stripe={stripePromise}
                  options={{
                    mode: 'payment',
                    // Must match the BFF PaymentIntent (manual capture). Capture happens after the
                    // provider booking succeeds; on failure the authorization is voided (no refund).
                    captureMethod: 'manual',
                    amount: finalAmount,
                    currency: (account?.currency ?? 'usd').toLowerCase(),
                  }}
                >
                  <ExpressCheckoutButtons
                    totalPrice={finalAmount}
                    formsRef={{
                      driverForm: driverFormRef,
                      emailForm: emailFormRef,
                      billingForm: billingRef,
                    }}
                    onExpressWalletAvailabilityResolved={onExpressWalletAvailabilityResolved}
                    isDisabled={isCardCompleteBookingDisabled}
                    type={StripeBtnTypes.Cars}
                    setMultiplePayments={setMultiplePayments}
                    paymentSelected={expressCheckoutPaymentSelected}
                  />
                </Elements>
              </div>)}
              {!suppressStripePaymentUI && showCompleteBookingButton && (
                <BlueButton
                  onClick={handleOnCompleteBooking}
                  disabled={isCardCompleteBookingDisabled}
                >
                  <FormattedMessage id="complete.booking" />

                  {loading || loadingBooking ? <Spin /> : null}
                </BlueButton>
              )}
            </>

            <ThreeDSModal isCars />

            {isSessionExpired ? (
              <div className="result-wrapper__expired-message">
                <ExpiredSessionModal
                  visible={isSessionExpired}
                  hasRedirect={true}
                  onHandleRedirect={handleRedirect}
                />
              </div>
            ) : null}
          </div>

          {!validateStripeBtns
            && <p style={{ fontWeight: 'bold' }} className='payment-complete-fields'>Please, fill in all required fields to proceed {' '}
              <u onClick={validateForm} style={{ cursor: 'pointer' }}>(View Fields)</u></p>}

          <InsuranceRequiredMessage
            display={insuranceRequiredMessageDisplay}
            insuranceContainerRef={
              insuranceContainerRef as React.RefObject<HTMLDivElement>
            }
            classNameContainer="review-book__wrapper"
          />

        </div>
      </div>
      {/* Full-page dim + spinner during the Stripe book-resume-express call (express wallet confirm
       *  → BFF resume) and during the regular card-flow booking. Matches the hotels/condo pattern
       *  of mounting GlobalLoading inside the inner review-book component (not just the outer
       *  wrapper) so the overlay is reliably in the React tree while these thunks are in flight. */}
      <GlobalLoading isVisible={stripeLoading} />
    </div>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    marginatorStore: state.marginatorStore,
    loginStore: state.loginStore,
    carsStore: state.carsStore,
    carsDetailsStore: state.carsDetailsStore,
    carsReviewBookStore: state.carsReviewBookStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  getBookPackageWithCard: getCarsBookPackageWithCard,
};

export const CarsDisclaimers = connect(mapStateToProps, mapDispatchToProps)(injectIntl(CarsDisclaimersComponent));

